import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function () {
    const feedbacksSlider = document.querySelector('.section-feedbacks__slider');

    if (feedbacksSlider) {
        const swiperContainer = feedbacksSlider.querySelector('.swiper-container');
        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        const totalSlides = slides.length;

        if (swiperContainer) {
            // 1. Проверяем количество: если <= 3, вешаем класс, который скроет стрелки через CSS
            if (totalSlides <= 3) {
                feedbacksSlider.classList.add('is-disabled');
            }

            new Swiper(swiperContainer, {
                modules: [Navigation],
                observer: true,
                observeParents: true,
                // Loop только если слайдов больше 3
                loop: totalSlides > 3, 
                watchOverflow: true,
                speed: 2000,
                navigation: {
                    nextEl: feedbacksSlider.querySelector('.slider-next'),
                    prevEl: feedbacksSlider.querySelector('.slider-prev'),
                },
                breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
                    768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1240: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
            });
        }
    }
});